'use client'

/**
 * Purpose: Loading spinner shown while survey face analysis runs after capture.
 * Inputs: None — copy comes from `survey.photo` translations.
 * Outputs: Static analyzing UI inside SurveyCameraCapture.
 */

import { useTranslations } from 'next-intl'

export function SurveyCameraAnalyzing() {
  const t = useTranslations('survey.photo')

  return (
    <div id="survey-camera-capture-analyzing" className="survey-camera-capture-analyzing">
      <div className="survey-camera-capture-spinner" />
      <p className="survey-camera-capture-analyzing-text">{t('analyzing')}</p>
    </div>
  )
}
